import src from "IMAGE";
export default { src, width: 240, height: 180, blurDataURL: "data:image/webp;base64,UklGRl4AAABXRUJQVlA4TFIAAAAvB0ABAM1VICICHghACgMAAIDjCQEAAAAAAAoCJQAAAAAAAAAAAAAAAAAAgCCAGDAiZmAwAK+8pwAAiIgUHEsUyuVq9R4T9L1/f9j4kFN0FrQB", blurWidth: 8, blurHeight: 6 }
